import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { LangText } from '@/components'
import { Segmented } from 'antd'

interface SignWaysProps {
  value: string
  onChange: (value: string) => void
}

const SignWays = (props: SignWaysProps) => {
  const { t } = useTranslation();
  const { value , onChange } = props;

  const options = useMemo(()=> {
    return [{
      labelKey: '88939319',
      value: 'phone',
    }
    , {
      labelKey: '0684da87',
      value: 'email',
    }
    // , {
    //   labelKey: '04291e21',
    //   value: 'wechat',
    // }
  ]
  },[])

  return (
    <div className='mt-4'>
      <Segmented
        className='w-full text-[16px]'
        value={value}
        onChange={onChange}
        options={
          options.map(option => {
            return {
              label: (
                // <div className='h-9 w-[111px] flex items-center justify-center'>
                <div className='h-9 w-[180px] flex items-center justify-center'>
                  <LangText lngKey={option.labelKey} className={value === option.value ? 'text-[#3096FF] font-bold' : 'text-[#666666]'}>{t(option.labelKey)}</LangText>
                </div>
              ),
              value: option.value,
            }
          })
        }
      />
    </div>
  )
}

export default SignWays